import { h } from 'preact'
import Phrase from '../../libs/translationsUtils/phrase'
import { FreshdeskHit } from '../algolia/components'

const FreshdeskResults = ({ hit, clickCallback }: { hit: FreshdeskHit, clickCallback: (hit: FreshdeskHit) => void }) => {
  return (
    <div onClick={() => clickCallback(hit)} className='qa-topic-block thread-list-item topic-view forum-list-view-spacing thread-list-item--freshdesk'>
      <span className='thread-list-item--index-label'>
        <Phrase m='Forum' p='federated.search.freshdesk' />
      </span>
      <h4 className='thread-list-block__title'>
        <a className='qa-topic-title thread-list-block__title-link' href={hit.url} target='_blank'>{ hit.title }</a>
      </h4>
      <p className='thread-list-block__content qa-topic-content'>
        <a href={hit.url} target='_blank'>{ hit.content }</a>
      </p>
    </div>
  )
}

export default FreshdeskResults
